import type { GridCoords } from '@/core/Board/types'
import { game } from '@/core/Game'
import { type CityStructure, CityZone, STRUCTURE_TO_LABEL } from '@/core/Game/constants'

import { STRUCTURE_GROUP_TO_LABEL, STRUCTURE_GROUPS, type StructureGroup } from './constants'

interface BuildMenuProps {
  gridZone: [start: GridCoords, end: GridCoords]
}
export function BuildMenu({ gridZone }: Readonly<BuildMenuProps>) {
  const changeStructure = (nextStructure: CityStructure) => {
    game.patchGridAtLevel(gridZone[0], gridZone[1], 0, CityZone.None, nextStructure)
  }

  return (
    <nav>
      <ul>
        {Object.entries(STRUCTURE_GROUPS).map(([structureGroup, structures]) => (
          <li>
            <strong>{STRUCTURE_GROUP_TO_LABEL[structureGroup as StructureGroup]}</strong>
            <ul>
              {structures.map(structure => (
                <li>
                  <button onClick={() => changeStructure(structure)} type="button">
                    {STRUCTURE_TO_LABEL[structure]}
                  </button>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  )
}
